<template>
	<section
		v-if="toShow"
	>
		<div class="shadow-box section-content">
			<div>
				<div class="flex wrap top-panel">
					<div class="flex-vcenter">
						<h2 class="label-text inline">
							{{ progressBarTitle }} 
						</h2>
						&nbsp;
						<span
							class="link-detail"
							@click="goToProfile()"
							v-if="order && menu"
							v-html="`(visualizza)`"
						/>
					</div>
					<div class="flex-right" v-if="order">
						Consegna prevista per {{ $_dates_readableDate(order && order.date.delivery) }}
					</div>
				</div>

				<tracking-code
					:order="order"
				/>

				<br>

				<div class="flex-vcenter">
					
					<div
						class="circle"
						:data-step-number='isOrderCreated ? 0 : 1'
					/>
					<div
						class="line"
						:data-step-number='[ isOrderProccessed ? 0 : 2]'
					/>
					<div
						class="circle"
						:data-step-number='[ isOrderProccessed ? 0 : 2]'
						:data-state='[ isOrderUnpaid ? "unpaid" : "paid"]'
					/>
					<div
						class="line"
						:data-step-number='[ isOrderShipped ? 0 : 3]'
					/>
					<div
						class="circle"
						:data-step-number='[isOrderShipped ? 0 : 3]'
					/>
					<div
						class="overlay"
						:class="{ 'loaded': isOrderShipped, 'half-loaded': (isOrderProccessed || isOrderUnpaid) }"
					/>
				</div>
				<div class="flex-vcenter">
					<div class="label">Creato</div>

					<div class="label">
						{{ isOrderUnpaid
							? 'Non pagato'
							: 'Pagato'
						}}
					</div>

					<div class="label">Elaborato e spedito</div>
				</div>
				<div>
					<i>
						{{ isOrderPaid
							? 'Non è più possibile modificarlo o cancellarlo'
							: null
						}}
					</i>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import TrackingCode from '../Profile/TrackingCode'
import { UserApi } from '../../api/UserApi'
import { Order } from '../../core/Order'
import { dates } from '../../mixins/dates'

import { menuStore } from '../../store/menuStore' 
import { deliveryStore } from '../../store/deliveryStore' 

const moment = require('moment')

export default {
	data () {
		return {
			order: null,

			menuStore: menuStore.state,
			deliveryStore: deliveryStore.state
		}
	},
	components: {
		TrackingCode
	},

	mixins: [
		dates
	],

	computed: {
		menu () {
			return this.menuStore.menu
		},
		isOrderCreated () {
			return this.order
		},

		isOrderProccessed () {
			return this.order && this.order.is_processed
		},

		isOrderPaid () {
			return this.order && this.order.is_processed && this.order.is_paid
		},

		isOrderUnpaid () {
			return this.order && this.order.is_processed && this.order.is_unpaid
		},

		isOrderShipped () {
			return this.order && this.isShipped
		},

		progressBarTitle () {
			if (!this.menu || !this.order) {
				return `Ultimo ordine chiuso`
			}
			if (moment(this.menu.date.start).isSame(moment(this.order.date.week_plan))) {
				return `Ordine elaborato #${this.order.id}`
			}
			if (moment(this.menu.date.start).isSame(moment(this.order.date.week_plan).add(7, 'days'))) {
				return `Ordine #${this.order.id} della scorsa settimana`
			}
			return `Ultimo ordine chiuso #${this.order.id}`
		},

		toShow () {
			return process.env.NODE_ENV === 'development'
				? true
				: this.$root.user.hasProcessedOrder()
		},

		delivery () {
            var order = this.order
            return this.deliveryStore
                && this.deliveryStore.deliveries.order.find(r => +r.attributes.target_id === +order.id)
                && this.deliveryStore.deliveries.order.find(r => +r.attributes.target_id === +order.id).attributes
        },

		isShipped () {
			if (!this.delivery) return
			var shipmentDayAfter20 = moment(this.order.date.week_plan)
				.add(this.delivery.shipment_day - 1 + 7, 'days')
				.hour(20)
				.locale('it')
				.format()
			var now = moment()
				.locale('it')
				.format()
			return this.order.is_paid && now > shipmentDayAfter20
		}
	},

	methods: {
		loadOrder () {
			var um = new UserApi()
			um.orders({
				page: 1,
				show: 1,
				sort: '-created_at',
				query: process.env.NODE_ENV === 'development'
					?  ''
					: 'processed eq 1'
			})

			.then(response => {
				if (response.body.resources.length > 0) {
					this.order = new Order(response.body.resources[0])
					this.loadDelivery()
				}
			})
		},

		goToProfile () {
			this.$router.push({ name: 'profile_orders', params: { orderId: this.order.id } })
		},

		loadDelivery () {
        	return deliveryStore.getDelivery({ 
	        	target_type: 'order', 
	        	target_id: this.order.id
	    	})
        }
	},

	mounted () {
		this.loadOrder()
		menuStore.loadCurrentMenu()
	}
}

</script>

<style scoped>

h2 {
	cursor: pointer;
}

h3 {
	font-size: 18px;
}
.flex-vcenter {
	align-items: baseline;
	position: relative;
}

.overlay {
	position: absolute;
	background: #ededed;
	right: 0;
	width: 100%;
	height: 4px;
	top: 50%;
    transform: translateY(-1px);
    transition: all 0.7s ease;
}

.overlay.half-loaded {
	width: 50%;
}

.overlay.loaded {
	width: 0%;
}

.label-text {
	text-align:left;
}
.circle {
	text-align: center;
	position: relative;
	flex-grow: 1;
	z-index: 1;
	background: white;
	
}

.circle::before {
	content: attr(data-step-number);
	display: flex;
	color: #ededed;
	justify-content: center;
	width: 40px;
	height: 40px;
	margin: 0px auto;
	align-items: center;
	font-size: 20px;
	border: 3px solid #ededed;
	border-radius: 50%;
	transition: all 0.7s ease;
}

.label {
	margin-top: 10px;
	flex-basis: calc(100% / 3);
	flex-grow: 1;
}

.label:first-child {
	text-align: left;
}

.label:nth-child(2) {
	text-align: center;
}

.label:nth-child(3) {
	text-align: right;
}

.line {
	margin: 0px 0;
	flex-basis: 100%;
	flex-grow: 1;
	height: 4px;
	background-color: #ededed;
	transform: translateY(-3px);
}

.circle[data-step-number="0"]::before {
	color: #fff;
	content: '\f00c';
	font-family: 'FontAwesome';
}

.circle[data-step-number="0"][data-state="unpaid"]::before,
.line[data-step-number="0"][data-state="unpaid"] {
	background-color: tomato;
	border: 2px solid tomato;
}

.circle[data-step-number="0"][data-state="unpaid"]::before {
	content: '\f00d';
}

.circle[data-step-number="0"]::before,
.line[data-step-number="0"] {
	background-color: var(--quomi-primary);
	border: 2px solid var(--quomi-primary);
}

@media (max-width: 800px) {
	.top-panel > div {
		flex-basis: 100%;
		text-align: left;
	}

	.top-panel {
		padding-bottom: 10px;
	}
}

@media (max-width: 600px) {
	.circle::before {
		width: 40px;
		height: 40px;
		font-size: 20px;
	}
}
</style>
